import React, { createContext, useState, useContext } from 'react';
import { Toast } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, variant = 'success') => {
    const id = Date.now();
    const newToast = { id, message, variant };
    setToasts(prev => [...prev, newToast]);

    // Auto remove após 5 segundos
    setTimeout(() => {
      removeToast(id);
    }, 5000);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const getIcon = (variant) => {
    switch (variant) {
      case 'success':
        return faCheckCircle;
      case 'danger':
        return faTimesCircle;
      case 'warning':
        return faExclamationTriangle;
      case 'info':
      default:
        return faInfoCircle;
    }
  };

  const getTitle = (variant) => {
    switch (variant) {
      case 'success':
        return 'Sucesso';
      case 'danger':
        return 'Erro';
      case 'warning':
        return 'Atenção';
      case 'info':
      default:
        return 'Informação';
    }
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div 
        style={{ 
          position: 'fixed', 
          top: '20px', 
          right: '20px', 
          zIndex: 9999,
          minWidth: '300px'
        }}
      >
        {toasts.map(toast => {
          const isDarkVariant = toast.variant === 'dark' || toast.variant === 'danger';
          const textColor = isDarkVariant ? 'text-white' : 'text-dark';
          
          return (
            <Toast
              key={toast.id}
              onClose={() => removeToast(toast.id)}
              show={true}
              delay={5000}
              autohide
              className={`bg-${toast.variant}`}
              style={{ marginBottom: '10px' }}
            >
              <Toast.Header className={`bg-${toast.variant} ${textColor} border-0`} style={{ color: isDarkVariant ? '#fff' : '#000' }}>
                <FontAwesomeIcon icon={getIcon(toast.variant)} className="me-2" />
                <strong className="me-auto">{getTitle(toast.variant)}</strong>
              </Toast.Header>
              <Toast.Body className={textColor} style={{ color: isDarkVariant ? '#fff' : '#000' }}>
                {toast.message}
              </Toast.Body>
            </Toast>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast deve ser usado dentro de ToastProvider');
  }
  return context;
};
